<template>
  <section id="app">
    <top-progress ref="progress" color="#1DD388" errorColor="red"></top-progress>
    <router-view></router-view>
  </section>
</template>

<script>
import TopProgress from 'vue-top-progress'

export default {
  name: 'app',
  components: {
    TopProgress
  },
  created () {
    // 页面组件加载进度显示
    this.$router.beforeEach((to, from, next) => {
      this.$refs.progress.start()
      next()
    })

    this.$router.afterEach((route) => {
      this.$nextTick(() => this.$refs.progress.done())
    })
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?11a7a65d